export default {
    appendMessage : (state, message) => (state.messages.push(message)),
    appendMessages: (state, messages) => (state.messages = messages),
    emptyMessages : (state) => (state.messages = [])
};
